module.exports = {
    json: require('./json/getJSON'),
    jsonGraph: require('./jsonGraph/getJSONGraph')
};



// WEBPACK FOOTER //
// ./lib/cache/get/index.js